export default __webpack_public_path__ + "static/media/fad-mute.078d9e0f.svg";